module.exports = __webpack_public_path__ + "static/media/person-brunno.3d1a184e.jpg";